module.exports = __webpack_public_path__ + "img/error.bfde0280.svg";